module.exports = __webpack_public_path__ + "img/industry-solution.63515ba5.jpg";